import React from 'react';
import { Col, ContactFieldManager, FMGModal, Form, Input, Row, Select, Typography } from 'components/index';
import { ValidationErrors } from 'constants/validations';
import { ClientContactPersonFormType } from 'typings/form';
import { useAddEditContactPerson } from 'components/common/contactPerson/addEdit/useAddContactPerson';

const { Item } = Form;

export interface IAddContactPerson {
  modalState: boolean;
  entityName: string;
  onModalStateChange: () => void;
  dataToEdit?: ClientContactPersonFormType;
  clientId?: string;
}

export const ContactPersonAddEdit = React.memo<IAddContactPerson>((props) => {
  const { onModalStateChange, dataToEdit, entityName, modalState, clientId } = props;
  const {
    form,
    contextHolder,
    disableSaveBtn,
    languageData,
    clientContactPersonContactList,
    onContactPersonSubmit,
    onCancel,
    onValuesChange,
    isLoading,
  } = useAddEditContactPerson({
    onModalStateChange,
    entityName,
    dataToEdit,
    modalState,
    clientId,
  });
  return (
    <>
      {contextHolder}
      <FMGModal
        title={`${dataToEdit ? 'Update' : 'Add'} Contact Person`}
        okText={dataToEdit ? 'Save' : 'Add'}
        open={modalState}
        isLoading={isLoading}
        disableOkBtn={disableSaveBtn}
        onCancel={onCancel}
        onSubmit={onContactPersonSubmit}
      >
        <Form
          layout={'vertical'}
          requiredMark={false}
          form={form}
          className={'margin-t-20'}
          onValuesChange={onValuesChange}
        >
          <Row justify={'space-between'} gutter={[16, 20]}>
            <Col span={12}>
              <Item
                label={'Full Name*'}
                name={'fullName'}
                rules={[{ required: true, message: ValidationErrors.required('Full Name') }]}
              >
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item
                label={'Language*'}
                name={'languageId'}
                rules={[{ required: true, message: ValidationErrors.required('Language') }]}
              >
                <Select
                  options={languageData}
                  size={'large'}
                  showSearch
                  filterOption={(input, option) => {
                    if (option) {
                      const label: string = option.label?.toString() || '';
                      return label?.toLowerCase()?.includes(input?.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Item>
            </Col>
            <Col span={12}>
              <Item label={'Department'} name={'department'}>
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item label={'Role'} name={'role'}>
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={24}>
              <Typography.Title level={5} style={{ color: '#05796B', margin: 0 }}>
                Contacts
              </Typography.Title>
            </Col>
            <Col span={24}>
              <ContactFieldManager modalState={modalState} dataToEdit={clientContactPersonContactList} form={form} />
            </Col>
          </Row>
        </Form>
      </FMGModal>
    </>
  );
});
